import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import { getLocalizedDate } from "@/utils/common";
import { Icon } from "@syarahtech/ui";
var OrderTypePill = function OrderTypePill(_ref) {
  var order = _ref.order,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    className: "inline-flex items-center gap-1 rounded-[12px] px-3 py-0.5 text-[10px] font-bold leading-4 whitespace-nowrap ".concat(className),
    style: {
      backgroundColor: order.payment_type_background,
      color: order.payment_type_text_color
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: order.payment_type_icon,
    alt: "Payment type icon",
    className: "w-4 h-4 shrink-0"
  }), order.order_title);
};
var PurchaseOrderCard = function PurchaseOrderCard(_ref2) {
  var order = _ref2.order,
    lang = _ref2.lang,
    link = _ref2.link;
  var localizedDate = getLocalizedDate(new Date(order.order_date), lang, false, "");
  return /*#__PURE__*/React.createElement(Link, {
    to: link,
    id: "purchase-order-card-".concat(order.id),
    className: "flex items-center gap-3 p-3 bg-white border border-solid border-[#d6dfe9] rounded-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shrink-0 w-[84px] h-[68px] lg:w-[120px] lg:h-[106px] rounded-lg overflow-hidden bg-[#f2f2f2]"
  }, /*#__PURE__*/React.createElement("img", {
    src: order.post_image,
    alt: order.post_title,
    className: "w-full h-full object-cover"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-0 flex flex-col items-start text-start gap-2 lg:gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col items-start text-start gap-0.5 lg:gap-[5px]"
  }, /*#__PURE__*/React.createElement("p", {
    className: "w-full truncate text-sm font-bold leading-6 text-[#00143c]"
  }, order.post_title), /*#__PURE__*/React.createElement("p", {
    className: "w-full truncate text-xs lg:text-sm font-normal lg:font-semibold leading-4 lg:leading-6",
    style: {
      color: order.color
    }
  }, order.status), /*#__PURE__*/React.createElement("p", {
    className: "w-full text-[10px] leading-4 text-[#6c7a8d]"
  }, localizedDate.day, "\u060C ", localizedDate.date)), /*#__PURE__*/React.createElement(OrderTypePill, {
    order: order,
    className: "lg:hidden"
  })), /*#__PURE__*/React.createElement(OrderTypePill, {
    order: order,
    className: "hidden lg:inline-flex shrink-0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "shrink-0 flex items-center ltr:rotate-180"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-back-ios-rounded",
    className: "text-primary-new",
    width: 4,
    height: 4
  })));
};
export default PurchaseOrderCard;